/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import ToggleMenu from "./modules/ToggleMenu";
import ProductsSlider from "./modules/ProductsSlider";
import ProductLinesSlider from "./modules/ProductLinesSlider";
import CollectionsCarouselSlider from "./modules/CollectionsCarouselSlider";
import MainSlider from "./modules/MainSlider";
import CategoriesSlider from "./modules/CategoriesSlider";
import Accordion from "./modules/Accordion";
import SetMainHeight from "./modules/SetMainHeight";
import QuantityButtons from "./modules/QuantityButtons";
import MyAccountReturns from "./modules/MyAccountReturns";
import MyAccountComplaint from "./modules/MyAccountComplaint";
import MyAccountOrders from "./modules/MyAccountOrders";
import SidebarSlider from "./modules/SidebarSlider";
import AddToCart from "./modules/AddToCart";
import BackBtn from "./modules/BackBtn";
import Search from "./modules/Search";
import Checkout from "./modules/Checkout";
import Cart from "./modules/Cart";
import Newsletter from "./modules/Newsletter";
import GetProductsByAttr from "./modules/GetProductsByAttr";
import Notices from "./modules/Notices";
import AutocompleteCities from "./modules/AutocompleteCities";
import MyAccountRegister from "./modules/MyAccountRegister";
import CommentForm from "./modules/CommentForm";
import BrowserLangModal from "./modules/BrowserLangModal";

document.addEventListener("DOMContentLoaded", function (event) {
    const toggleMenu = new ToggleMenu();
    const productSlider = new ProductsSlider();
    const productLinesSlider = new ProductLinesSlider();
    const collectionsCarouselSlider = new CollectionsCarouselSlider();
    const categoriesSlider = new CategoriesSlider();
    const mainSlider = new MainSlider();
    const sidebarSlider = new SidebarSlider();
    const myAccordions = new Accordion("jsAccordionHeader");
    // const setMainHeight = new SetMainHeight();
    const quantity = new QuantityButtons();
    const accountReturns = new MyAccountReturns();
    const accountComplaint = new MyAccountComplaint();
    const accountOrders = new MyAccountOrders();
    const backBtn = new BackBtn();
    const initSearch = new Search();
    const myCheckout = new Checkout();
    const addToCart = new AddToCart();
    const myCartPage = new Cart();
    const newsletter = new Newsletter();
    const getProductsByAttr = new GetProductsByAttr();
    // const initAutocompleteCities = new AutocompleteCities();
    const myMyAccountRegister = new MyAccountRegister();
    const initCommentForm = new CommentForm();
    const initBrowserLang = new BrowserLangModal();

    if (window.global.check_or_cart) {
        const notices = new Notices();
    }

    addToCart.init();
    getProductsByAttr.init();
});
